import { environment } from '../../environments/environment'

class MenuUtils {
    adicionarNavbarScript() {
        const head = document.querySelector('head')
        const scriptNavbar = document.createElement('script')
        scriptNavbar.setAttribute('type', 'module')
        scriptNavbar.setAttribute('src', `${environment.menuUrl}/components/wc-navbar.js`)
        head.appendChild(scriptNavbar)
    }

    adicionarMenuScript() {
        const head = document.querySelector('head')
        const scriptMenu = document.createElement('script')
        scriptMenu.setAttribute('type', 'module')
        scriptMenu.setAttribute('src', `${environment.menuUrl}/components/wc-menu.js`)
        head.appendChild(scriptMenu)
    }

    adicionarNavbarElement(userConnection, operador) {
        const pessoaLogada = this._getPessoaLogada(operador, userConnection)
        const userConnectionMenu = this._getUserConnection(userConnection)
        this._adicionarNavbarElement(userConnectionMenu, pessoaLogada)
    }

    adicionarMenuElement(userConnection, operador) {
        const pessoaLogada = this._getPessoaLogada(operador, userConnection)
        const userConnectionMenu = this._getUserConnection(userConnection)
        this._adicionarMenuElement(userConnectionMenu, pessoaLogada)
    }

    private _adicionarNavbarElement(userConnection, pessoaLogada) {
        const containerMenu = document.querySelector('.container-menu')
        const navbarElement = document.createElement('wc-econt-navbar') as HTMLMenuElement
        navbarElement.style.position = 'fixed'
        navbarElement.style.zIndex = '20'
        navbarElement.style.right = '0'
        navbarElement.userConnection = userConnection
        navbarElement.pessoaLogada = pessoaLogada
        containerMenu.appendChild(navbarElement)
    }

    private _adicionarMenuElement(userConnection, pessoaLogada) {
        const containerMenu = document.querySelector('.container-menu')
        const menuElement = document.createElement('wc-econt-menu') as HTMLMenuElement
        menuElement.style.position = 'fixed'
        menuElement.style.zIndex = '21'
        menuElement.userConnection = userConnection
        menuElement.pessoaLogada = pessoaLogada
        containerMenu.appendChild(menuElement)
    }

    private _getPessoaLogada(operador, userConnection) {
        let tipoPessoa = operador.tipo.toUpperCase().includes('COLABORADOR') ? 1 : 2

        const pessoaLogada = {
            Permissoes: operador.permissoesObj,
            isSuperAdm: operador.id == '1',
            Administrador: operador.administra,
            TipoDePessoa: tipoPessoa,
            IsContador: tipoPessoa == 1,
            userConnection: userConnection,
            IsFreemiumFaltandoInformacoesDoContador:
                userConnection.IsFreemiumFaltandoInformacoesDoContador,
            nome: operador.nome,
            login: operador.login,
            email: operador.email,
            foto: operador.foto? operador.foto.imagem : null
        }

        return pessoaLogada
    }

    private _getUserConnection(userConnection) {
        const novoUserConnection = {
            UtilizaVersaoFreemium: userConnection.freemium,
            Current: {
                UtilizaVersaoFreemium: userConnection.freemium,
                UtilizaPackCND: userConnection.cnder,
                UtilizaConciliador: userConnection.collecter,
                UtilizaPackCRM: userConnection.crmer,
                UtilizaKaroo: userConnection.karooer,
                UtilizaTarefasWeb: userConnection.tareferWeb,
                IsPilotoTarefas: userConnection.isPilotoTarefas,
                UtilizaAutomacaoExtrato: userConnection.utilizaeExtrato,
                UtilizaRadarEcac: userConnection.utilizaRadarEcac,
                Pacote: {
                    Id: null,
                    Recursos: [],
                },
                RecursosEmFasePiloto: []
            },
        }

        if (userConnection.pacote && userConnection.pacote.recursos) {
            novoUserConnection.Current.Pacote = {
                Id: userConnection.pacote.id,
                Recursos: [],
            }
            novoUserConnection.Current.Pacote.Recursos =
                userConnection.pacote.recursos.map((recurso) => {
                    return { Id: recurso.id, Descricao: recurso.descricao }
                })
        }

        if(userConnection.recursosEmFasePiloto) {
            novoUserConnection.Current.RecursosEmFasePiloto = userConnection.recursosEmFasePiloto.map((recurso) => {
                return { Id: recurso.id, Descricao: recurso.descricao, EmFasePiloto: recurso.recursosEmFasePiloto };
            })
        }

        return novoUserConnection
    }
}

export const menuUtils = new MenuUtils()

interface HTMLMenuElement extends HTMLElement {
    userConnection
    pessoaLogada
}



// WEBPACK FOOTER //
// ./src/app/menu/menu.utils.ts